module.exports = __webpack_public_path__ + "static/media/subcriptionActiveIcon.42bdc789.svg";